import { render } from "./MockupInkboards2.vue?vue&type=template&id=22066e40&ts=true&lang=pug"
import script from "./MockupInkboards2.vue?vue&type=script&lang=ts"
export * from "./MockupInkboards2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__